import { useFormikContext } from 'formik';
import React from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../../../../../common/intl';
import { companyActions, companySelectors } from '../../../../../state/ducks/company';
import { Company } from '../../../../../state/ducks/company/types';
import useActionCreator from '../../../../hooks/useActionCreator';
import useAsync from '../../../../hooks/useAsync';
import DisplayComponent from '../../components/Display';
import EditingComponent from '../../components/Editing';
import SettingsPanel from '../../components/Panels';
import { SettingsPanelProps } from '../../types';

const ApprovalRequestsSettingsPanel: React.FC<SettingsPanelProps> = (props) => {
  const companyNameValue = useSelector(companySelectors.companyNameSelector);
  const [companyName, setCompanyName] = React.useState(companyNameValue);
  const [isEditing, setIsEditing] = React.useState(false);
  const { setFieldValue } = useFormikContext<Company>();
  const isNameEmpty = companyName.trim().length === 0;

  const async = useAsync({
    onSuccess: (values?: Company) => {
      setCompanyName(values?.name ?? '');
    },
    onError: () => {
      setCompanyName(companyNameValue);
    },
  });
  const changeCompanyAction = useActionCreator(companyActions.updateCompanyMine);

  React.useEffect(() => {
    setCompanyName(companyNameValue);
  }, [companyNameValue]);

  const onEdit = () => {
    setIsEditing(!isEditing);
  };

  const onSave = () => {
    if (isNameEmpty) {
      return;
    }
    async.start(changeCompanyAction, { name: companyName }, async);
    setIsEditing(false);
  };

  const onCancel = () => {
    setCompanyName(companyNameValue);
    setFieldValue('name', companyNameValue);
    setIsEditing(false);
  };

  const onChange = (address: string) => {
    setCompanyName(address);
    setFieldValue('name', address);
  };

  return (
    <SettingsPanel {...props} title={translate('administration.company.information.panel.title.name')}>
      {isEditing ? (
        <EditingComponent
          {...{ onSave, onChange, onCancel }}
          value={companyName}
          hasError={isNameEmpty}
          errorLabel={translate('administration.company.information.panel.title.name')}
        />
      ) : (
      <DisplayComponent displayValue={companyName} {...{ onEdit }} />
      )}
    </SettingsPanel>
  );
};

export default ApprovalRequestsSettingsPanel;
